module.exports = __webpack_public_path__ + "static/img/cer.c1025a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cer.png
// module id = 788
// module chunks = 1